export const AUTH__LOGOUT = () => {
    return {
        type: 'AUTH__LOGOUT',
    }
}
